import { memo } from "react";
import { Flex, Tag, Typography } from "antd";

import { NAVY, BRAND } from "./constants";

const { Title } = Typography;

// Accordion panel header: icon chip + uppercase title + count tag.
const PanelHeader = ({ icon, title, count }) => (
    <Flex align="center" gap={12}>
        <span
            style={{
                width: 38, height: 38, borderRadius: 10, display: "grid", placeItems: "center",
                background: NAVY, color: BRAND, fontSize: 18, flexShrink: 0,
            }}
        >
            {icon}
        </span>
        <Title level={5} style={{ margin: 0, textTransform: "uppercase", letterSpacing: 0.5 }}>
            {title}
        </Title>
        <Tag
            style={{
                borderRadius: 999, marginInlineStart: 4, border: "none",
                background: BRAND, color: NAVY, fontWeight: 700,
            }}
        >
            {count}
        </Tag>
    </Flex>
);

export default memo(PanelHeader);
